import { render } from "./MediaGroup.vue?vue&type=template&id=26fc4d58"
import script from "./MediaGroup.vue?vue&type=script&lang=js"
export * from "./MediaGroup.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__